import React from 'react';

import {
  CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG,
  CREATE_OR_ADD_TO_BUNDLE_QUANTITIES,
  CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG,
  CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG,
  CREATE_OR_ADD_TO_TRUCKLOAD_DIALOG,
  DOWNLOAD_BILL_OF_LADING_DIALOG,
  DOWNLOAD_PRODUCTION_PACKAGE_DIALOG,
  EDIT_SCHEDULE_GROUP_DIALOG,
  EDIT_SCHEDULE_LINE_GROUP_DIALOG,
  EDIT_TRUCKLOAD_DIALOG,
} from '../../actions/dialogActions';
import { useAppSelector } from '../hooks';
import { CreateOrAddToBundleQuantitiesDialog } from './CreateOrAddToBundleQuantitiesDialog';
import { DownloadBillOfLadingDialog } from './DownloadBillOfLadingDialog';
import { DownloadProductionPackageDialog } from './DownloadProductionPackageDialog';
import { CreateOrAddToScheduleGroupDialog } from './schedule-groups/CreateOrAddToScheduleGroupDialog';
import { EditScheduleGroupDialog } from './schedule-groups/EditScheduleGroupDialog';
import { CreateOrAddToScheduleLineGroupDialog } from './schedule-line-groups/CreateOrAddToScheduleLineGroupDialog';
import { EditScheduleLineGroupDialog } from './schedule-line-groups/EditScheduleLineGroupDialog';
import { ConfirmRemoveBundleFromTruckloadDialog } from './truckloads/ConfirmRemoveBundleFromTruckloadDialog';
import { CreateOrAddToTruckloadDialog } from './truckloads/CreateOrAddToTruckloadDialog';
import { EditTruckloadDialog } from './truckloads/EditTruckloadDialog';

export function DialogContainer() {
  const popupState = useAppSelector((state) => state.popup);

  switch (popupState.popupName) {
    case CREATE_OR_ADD_TO_BUNDLE_QUANTITIES:
      return <CreateOrAddToBundleQuantitiesDialog />;

    case CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG:
      return <CreateOrAddToScheduleGroupDialog />;

    case EDIT_SCHEDULE_GROUP_DIALOG:
      return <EditScheduleGroupDialog {...popupState.options} />;

    case CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG:
      return <CreateOrAddToScheduleLineGroupDialog />;

    case EDIT_SCHEDULE_LINE_GROUP_DIALOG:
      return <EditScheduleLineGroupDialog {...popupState.options} />;

    case CREATE_OR_ADD_TO_TRUCKLOAD_DIALOG:
      return <CreateOrAddToTruckloadDialog {...popupState.options} />;

    case EDIT_TRUCKLOAD_DIALOG:
      return <EditTruckloadDialog {...popupState.options} />;

    case CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG:
      return <ConfirmRemoveBundleFromTruckloadDialog {...popupState.options} />;

    case DOWNLOAD_PRODUCTION_PACKAGE_DIALOG:
      return <DownloadProductionPackageDialog {...popupState.options} />;

    case DOWNLOAD_BILL_OF_LADING_DIALOG:
      return <DownloadBillOfLadingDialog {...popupState.options} />;

    case null:
    default:
      return null;
  }
}
